import { useEffect } from "react";
import { Objective, OBJECTIVE_TYPE } from "../../interfaces";

import "../../styles/questedit.css";

export const ObjectiveEdit = ({
    objective,
    updateObjective,
}: {
    objective: Objective;
    updateObjective: (x: Objective) => void;
}) => {
    useEffect(() => {
        if (objective.type === OBJECTIVE_TYPE.FACT) {
            updateObjective({ ...objective, goal: 1 });
        }
    }, [objective.type]);

    const handleGoalChange = (val: string) => {
        if (Number.isNaN(Number.parseInt(val))) return;

        updateObjective({ ...objective, goal: +val });
    };

    return (
        <div className="addObjectiveFields">
            <input
                className="title"
                type="text"
                placeholder="title"
                value={objective.title}
                onChange={(e) =>
                    updateObjective({ ...objective, title: e.target.value })
                }
            />

            <div className="typePicker">
                <label className="typeRadio">
                    Fact
                    <input
                        type="radio"
                        name="type"
                        checked={objective.type === OBJECTIVE_TYPE.FACT}
                        onChange={() =>
                            updateObjective({
                                ...objective,
                                type: OBJECTIVE_TYPE.FACT,
                            })
                        }
                    />
                </label>
                <label className="typeRadio">
                    Count
                    <input
                        type="radio"
                        name="type"
                        checked={objective.type === OBJECTIVE_TYPE.COUNT}
                        onChange={() =>
                            updateObjective({
                                ...objective,
                                type: OBJECTIVE_TYPE.COUNT,
                            })
                        }
                    />
                </label>
            </div>

            {objective.type === OBJECTIVE_TYPE.COUNT && (
                <input
                    className="countInput"
                    type="number"
                    placeholder="Goal"
                    value={objective.goal}
                    onChange={(e) => handleGoalChange(e.target.value)}
                />
            )}
        </div>
    );
};
